//Navigations
var openMenus = document.querySelectorAll(".open-menu");
var container = document.querySelector(".content");
var header = document.querySelector("header");
var body = document.body;
function scrollControl() {
  if (container.classList.contains("menu-open")) {
    var scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    body.style.position = "fixed";
    body.style.width = "99%";
    body.style.right = "1%";
    body.style.top = "-".concat(scrollY);
  } else {
    var scrollY = body.style.top;
    body.style.position = "";
    body.style.width = "";
    body.style.right = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
  window.addEventListener("scroll", function () {
    document.documentElement.style.setProperty(
      "--scroll-y",
      "".concat(window.scrollY, "px")
    );
  });
}

function calcNavMargin() {
  container.style.marginTop = header.offsetHeight + "px";
}

gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);

function headerScroll() {
  const headerWrap = document.querySelector("header .header-wrap");
  const mainLogo = document.querySelector(".main-logo a");
  const mainNav = document.querySelector(".header-wrap .main-nav") || null;
  const topBanner = document.querySelector("header .top-banner") || null;
  const topBannerText =
    document.querySelector("header .top-banner a p") || null;
  const animTrigger = {
    trigger: ".content",
    start: 80,
    end: 81,
    toggleActions: "play none reverse none",
    pin: false,
  };

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": function () {
      const tlHeader = gsap.timeline({ scrollTrigger: animTrigger });
      const tlLogo = gsap.timeline({ scrollTrigger: animTrigger });
      const tlContent = gsap.timeline({ scrollTrigger: animTrigger });

      tlHeader.fromTo(
        headerWrap,
        { paddingTop: 15, paddingBottom: 15 },
        { paddingTop: 5, paddingBottom: 5, ease: "sine.inOut", duration: 0.3 }
      );
      tlLogo.to(mainLogo, {
        height: 50,
        ease: "sine.inOut",
        duration: 0.3,
      });
      tlContent.to(container, {
        marginTop: () => {
          return mainNav?.offsetHeight || headerWrap.offsetHeight;
        },
        ease: "sine.inOut",
        duration: 0.3,
      });
    },
    "(max-width: 1024px)": function () {
      gsap.timeline().to(headerWrap, {
        paddingTop: 7,
        paddingBottom: 7,
        ease: "sine.inOut",
        duration: 0,
      });
    },
    "(min-width: 320px)": function () {
      const tlBannerText = gsap.timeline({ scrollTrigger: animTrigger });
      const tlBanner = gsap.timeline({ scrollTrigger: animTrigger });

      if (topBannerText) {
        tlBanner.to(topBanner, { duration: 0.2, padding: 0, marginBottom: 0, lineHeight: 0});
        tlBannerText
          .set(topBannerText, { opacity: 1 })
          .to(topBannerText, { duration: 0.2, opacity: 0 })
          .to(topBannerText, { duration: 0.2, fontSize: 0 });
      }
    },
  });
}

for (let i = 0; i < openMenus.length; i++) {
  const currentOpen = openMenus[i];
  const nextNode = currentOpen.nextElementSibling;
  var mobileWidth = "100%";
  var desktopWidth = "50%";
  function setWidth() {
    if (window.matchMedia("(min-width:1024px)").matches) {
      return desktopWidth;
    } else {
      return mobileWidth;
    }
  }
  function resizeWidth() {
    window.addEventListener("resize", function () {
      if (
        nextNode.classList.contains("open") &&
        window.matchMedia("(min-width:1025px)").matches
      ) {
        nextNode.style.width = "50%";
      } else if (
        nextNode.classList.contains("open") &&
        window.matchMedia("(max-width:1024px)").matches
      ) {
        nextNode.style.width = "100%";
      } else {
        nextNode.style.width = "0";
      }
    });
  }
  const tl = gsap.timeline({
    reversed: true,
    paused: true,
  });
  tl.to(nextNode, {
    duration: 1,
    width: setWidth(),
    ease: "power2.out",
    onStart: () => {
      nextNode.classList.remove("closed");
    },
    onReverseComplete: () => {
      nextNode.classList.add("closed");
    }

  });
  const children = nextNode.querySelectorAll('[data-animate="true"]');
  const childTween = gsap.timeline();
  gsap.set(children, {
    opacity: 0,
    x: 180,
  });
  function open() {
    childTween.timeScale(1);
    childTween.to(children, {
      opacity: 1,
      x: 0,
      duration: 0.5,
      delay: 0.6,
      stagger: 0.025,
      ease: "power1.out",
      overwrite: "auto",
    });
  }
  function close() {
    childTween.timeScale(99);
    childTween.to(children, {
      opacity: 0,
      x: 180,
      duration: 0.2,
      ease: "power1.out",
      overwrite: "auto",
    });
  }

  function closeMenu() {
    currentOpen.classList.remove("active");
    nextNode.classList.remove("open");
    container.classList.remove("menu-open");
    tl.reverse(0.3);
    close();
    var scrollY = body.style.top;
    body.style.position = "";
    body.style.width = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    
    // Detect click outside the menu container
    document.addEventListener('click', function(event) {
     
    event.stopPropagation(); 
    const menuButton = document.querySelector('.open-menu.active');
    const menuOverlay = document.querySelector('.menu-overlay.open');
    // Check if the click is outside of the menu container
    if (!menuButton || !menuOverlay) return;
    if (
      !menuButton.contains(event.target) && 
      !menuOverlay.contains(event.target) 
    ) {
      closeMenu(); 
    }
    });

  currentOpen.addEventListener("click", function (event) {
    currentOpen.classList.toggle("active");
    nextNode.classList.toggle("open");
    container.classList.toggle("menu-open");
    tl.reversed() ? tl.play() : tl.reverse(0.3);
    tl.reversed() ? close() : open();
    scrollControl();
    resizeWidth();
  });
}
window.addEventListener("resize", calcNavMargin);
calcNavMargin();
headerScroll();
